import _ from 'underscore';
import $ from 'jquery';

export default class UserProductGroupSpecs {
  constructor($scope, UserProductService) {
    function open_dialog(dialog_id) {
      $.fancybox($('div#' + dialog_id), {
        padding: '5',
        scrolling: 'yes',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15
      });
    }

    $scope.tabs = ['Reels Specs', 'Sheets Specs'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.$on('open_group_specs_dialog', function(event, args) {
      $scope.get_group_specs(args.group_id);
    });

    $scope.get_group_specs = function(group_id) {
      UserProductService.get_group_specs_for_admin_view(group_id).then(function(data) {
        $scope.dialog_specs = data.specs;
        $scope.dialog_combinations = data.combinations;
        open_dialog('group_specs_dialog');
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.reels_substance_mode = 'both';
      $scope.reels_rw_mode = 'both';
      $scope.sheets_substance_mode = 'both';
      $scope._ = _;
    };

    $scope.init();
  }
}

UserProductGroupSpecs.$inject = ['$scope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-group-specs.ctrl.js